<template>
  <div class="com-lol-match-record-card" :class="dataInfo.type">
    <component v-if="is_show" :is="curCpt" :data-info="card_data"></component>
    <com-footer @click.native="openMatch">
      <OutOpen
        :protocol="heyboxProtocol"
        :page-identifier="'bbs/link'"
        v-if="canUseDeepLink && articleInfo.source == 'share'"
      ></OutOpen>
    </com-footer>
  </div>
</template>
<script>
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import comBanPick from './components/com-ban-pick.vue';
import comEcoTable from './components/com-eco-table.vue';
import comFooter from './components/com-footer.vue';
import { CptMixin } from '../../../mixins/CptMixin';
import OutOpen from '_com/OutOpen';
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  components: {
    comBanPick,
    comEcoTable,
    comFooter,
    OutOpen,
  },
  data() {
    return {
      card_data: {},
      is_show: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const result = await this.dataInfo.request(this.dataInfo.game_id);
      if (!result) return;

      this.card_data = result;
      if (result.stat != 0) {
        this.is_show = true;
      }
    },
    openMatch() {
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(this.heyboxProtocol);
          break;
        }
        case 'post': {
          executeProtocol(this.heyboxProtocol);
          break;
        }
      }
    },
  },
  computed: {
    curCpt() {
      switch (this.dataInfo.type) {
        case 'ban_pick':
          return comBanPick;
        case 'timeline':
          return comEcoTable;
        default:
          return '';
      }
    },
    heyboxProtocol() {
      let protocol = {
        protocol_type: 'openWindow',
        full_screen: true,
        mini_program: '1',
        mini_program_id: '24',
        status_bar: {
          style: 'light',
        },
        navigation_bar: {
          title: ' ',
          right_icon: {
            enabled: false,
          },
        },
        webview: {
          url:
            window.$WEB_HOST +
            `/tools/match_center/match_detail?match_id=${this.dataInfo.id}`,
          pull: false,
          refresh: false,
        },
      };
      return 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
    },
  },
};
</script>

<style lang="less" scoped>
.com-lol-match-record-card {
  position: relative;
  margin-top: 12px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  &.ban_pick {
    height: 149px;
  }
  &.timeline {
    height: 313px;
  }
}
</style>
